export default {
  departments: null,
  cities: null,
  shippingInfo: null,
  deliveryTypes: null,
  shippingInput: {
    region: null,
    city: null
  }
}
